import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const titleTransactionTypeMap: Record<TitleTransactionType, MapItem> = {
  purchase: { label: 'Purchase' },
  refinance: { label: 'Refinance' },
  sale: { label: 'Sale' },
  commercial_transaction: { label: 'Commercial Transaction' },
  other: { label: 'Other' },
}

// Schema that includes both the type and optional custom value
export const titleTransactionTypeSchema = z.enum(
  Object.keys(titleTransactionTypeMap) as [TitleTransactionType, ...TitleTransactionType[]],
)

export type TitleTransactionType = 'purchase' | 'refinance' | 'sale' | 'commercial_transaction' | 'other'

export type TitleTransactionTypeWithCustom = z.infer<typeof titleTransactionTypeSchema>
